/** @jsxRuntime classic */
/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/react';
import dayjs from 'dayjs';
import { i18n } from '../../../lib/i18n';
import { MembershipStatusEnum } from './types';
import { iconMapper, membershipStatusColorMapper } from './utils';
import { IconWithTooltip } from '../../IconWithTooltip';
import { EDateFormats } from '../../../lib/timeUtils';

export interface Props {
	membershipStatus: MembershipStatusEnum;
	size?: number;
	pauseEndDate?: string | Date;
}

export const MembershipStatusIndication = ({ membershipStatus, size = 16, pauseEndDate }: Props) => {
	const membershipStatusMapper = i18n.membershipStatusMapper;
	const membershipStatusTooltipsMapper = i18n.membershipStatusToolTips;

	let tooltipText = membershipStatusMapper[membershipStatus];
	if (membershipStatus === MembershipStatusEnum.PAUSE_PENDING) {
		tooltipText = membershipStatusTooltipsMapper[MembershipStatusEnum.PAUSE_PENDING];
	} else if (pauseEndDate && membershipStatus === MembershipStatusEnum.PAUSED) {
		tooltipText = membershipStatusTooltipsMapper[MembershipStatusEnum.PAUSED](
			dayjs(pauseEndDate).format(EDateFormats.MMM_D_YYYY)
		);
	}

	return (
		<IconWithTooltip
			icon={iconMapper[membershipStatus]}
			text={tooltipText}
			color={membershipStatusColorMapper[membershipStatus]}
			size={size}
			isTopLayer
		/>
	);
};
